import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase-config";

/**
 * Ajoute une ligne au panier Firestore pour l'utilisateur courant (uid obligatoire).
 * quantity est bornée à 1 minimum.
 */
export async function addProductToPanier(product, userId, quantity = 1) {
  if (!userId) {
    throw new Error("Connexion requise pour ajouter au panier.");
  }
  const safeQuantity = Number.isFinite(quantity) ? Math.max(1, Math.floor(quantity)) : 1;
  return addDoc(collection(db, "panier"), {
    userId,
    id: product.id,
    slug: product.slug,
    name: product.name,
    category: product.category,
    price: product.price,
    image: product.image,
    stripePriceId: product.stripePriceId,
    quantity: safeQuantity,
    selected: true,
    createdAt: serverTimestamp(),
  });
}
